import axios from 'axios';
import { API_URL } from '../constants/index.js';
import { useInterceptor } from './apiUtils';

useInterceptor(axios);

/** Unified CMS journey booking preview — mode: group | private */
export function previewJourneyBooking({ journey_slug, mode, year_month, journey_title, travellers }) {
	return axios({
		method: 'get',
		url: `${API_URL}/journey_bookings/preview`,
		params: { journey_slug, mode, year_month, journey_title, travellers },
	});
}

/** Private tour estimated pricing (symmetric with group_departures/lookup) */
export function lookupPrivateJourney({ journey_slug, journey_title, travellers }) {
	return axios({
		method: 'get',
		url: `${API_URL}/private_journeys/lookup`,
		params: { journey_slug, journey_title, travellers },
	});
}
